/* CultCampus theme JS – vanilla, no dependencies */
(function () {
  'use strict';
  var CC = window.CC = window.CC || {};
  var doc = document;
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }

  /* ---------- money ---------- */
  function group(n, sep, dec, decimals, indian) {
    var s = n.toFixed(decimals).split('.');
    var i = s[0];
    if (indian && i.length > 3) {
      var last = i.slice(-3), rest = i.slice(0, -3);
      i = rest.replace(/\B(?=(\d{2})+(?!\d))/g, sep) + sep + last;
    } else {
      i = i.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    return s[1] ? i + dec + s[1] : i;
  }
  CC.money = function (cents) {
    var f = CC.moneyFormat || '{{amount}}';
    var v = cents / 100, ind = CC.currency === 'INR';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      switch (t) {
        case 'amount_no_decimals': return group(v, ',', '.', 0, ind);
        case 'amount_with_comma_separator': return group(v, '.', ',', 2, false);
        case 'amount_no_decimals_with_comma_separator': return group(v, '.', ',', 0, false);
        case 'amount_with_apostrophe_separator': return group(v, "'", '.', 2, false);
        case 'amount_no_decimals_with_space_separator': return group(v, ' ', '.', 0, false);
        case 'amount_with_space_separator': return group(v, ' ', ',', 2, false);
        case 'amount_with_period_and_space_separator': return group(v, ' ', '.', 2, false);
        default: return group(v, ',', '.', 2, ind);
      }
    });
  };

  /* ---------- toast ---------- */
  var toastTimer;
  CC.toast = function (msg, linkText, linkHref) {
    var t = $('#cc-toast'); if (!t) return;
    t.textContent = msg;
    if (linkText) {
      var a = doc.createElement('a'); a.href = linkHref; a.textContent = linkText; t.appendChild(a);
    }
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3200);
  };

  /* ---------- cart count ---------- */
  CC.setCount = function (n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = !n;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };
  CC.refreshCount = function () {
    return fetch(CC.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CC.setCount(c.item_count); return c; });
  };

  /* ---------- drawer & search ---------- */
  var drawer = $('#cc-drawer'), overlay = $('.cc-drawer-overlay');
  function openDrawer() {
    doc.body.classList.add('drawer-open'); if (overlay) overlay.hidden = false;
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer() {
    doc.body.classList.remove('drawer-open'); if (overlay) overlay.hidden = true;
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function toggleSearch(force) {
    var p = $('#cc-search'); if (!p) return;
    var open = typeof force === 'boolean' ? force : p.hidden;
    p.hidden = !open;
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) { var i = $('input[type=search]', p); if (i) i.focus(); }
  }

  /* ---------- add to cart ---------- */
  function addToCart(form, buyNow) {
    var scope = form.closest('[data-product-root]') || doc;
    var btns = $$('[data-add-btn]', doc), msg = $('[data-form-msg]', scope);
    if (msg) msg.textContent = '';
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    var fd = new FormData(form);
    return fetch(CC.routes.cartAdd + '.js', {
      method: 'POST', body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.j.description || res.j.message || CC.strings.error); }
        if (buyNow) { window.location.href = '/checkout'; return; }
        return CC.refreshCount().then(function () {
          CC.toast(CC.strings.added, CC.strings.viewCart, CC.routes.cart);
        });
      })
      .catch(function (err) {
        if (msg) msg.textContent = err.message; else CC.toast(err.message);
      })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[name=id]', form);
    var addBtns = $$('[data-add-btn]', doc), buyBtn = $('[data-buy-now]', root);
    var priceEls = $$('[data-price]', doc), cmpEl = $('[data-compare]', root), offEl = $('[data-off]', root);
    var invEl = $('[data-inv]', root), invMap = {};
    try { invMap = JSON.parse($('[data-inv-map]', root).textContent); } catch (e) {}
    var qtyInput = $('[data-qty-input]', root);

    function selectedOptions() {
      var vals = [];
      $$('[data-option-group]', root).forEach(function (g, i) {
        var checked = $('input:checked', g), sel = $('select', g);
        vals[i] = checked ? checked.value : (sel ? sel.value : null);
        var lbl = $('[data-opt-label]', g.parentNode); if (lbl) lbl.textContent = vals[i];
      });
      return vals;
    }
    function findVariant(vals) {
      if (product.variants.length === 1) return product.variants[0];
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return vals[i] === o; });
      })[0];
    }
    function showSlide(mediaId) {
      var slides = $$('[data-slide]', root); if (!slides.length) return;
      var idx = 0;
      slides.forEach(function (s, i) { if (String(s.dataset.mediaId) === String(mediaId)) idx = i; });
      setSlide(idx);
    }
    function setSlide(idx) {
      $$('[data-slide]', root).forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      $$('[data-thumb]', root).forEach(function (t, i) { t.classList.toggle('thumb-active', i === idx); });
    }
    function update() {
      var v = findVariant(selectedOptions());
      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; b.textContent = CC.strings.unavailable; });
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = CC.money(v.price); });
      if (cmpEl) cmpEl.textContent = v.compare_at_price > v.price ? CC.money(v.compare_at_price) : '';
      if (offEl) offEl.textContent = v.compare_at_price > v.price ? 'SAVE ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : '';
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        var withPrice = b.hasAttribute('data-with-price');
        b.innerHTML = v.available ? CC.strings.addToCart + (withPrice ? ' — ' + CC.money(v.price) + ' →' : '') : CC.strings.soldOut;
      });
      if (invEl) {
        var q = invMap[v.id], th = parseInt(invEl.dataset.threshold, 10);
        if (q != null && q > 0 && q <= th) { invEl.textContent = invEl.dataset.text.replace('{n}', q); invEl.hidden = false; } else { invEl.hidden = true; }
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (v.featured_media) showSlide(v.featured_media.id);
      if (history.replaceState && product.variants.length > 1) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-group]')) update(); });
    $$('[data-thumb]', root).forEach(function (t, i) { t.addEventListener('click', function () { setSlide(i); }); });
    if (qtyInput) {
      root.addEventListener('click', function (e) {
        var m = e.target.closest('[data-qty-minus]'), p = e.target.closest('[data-qty-plus]');
        if (!m && !p) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        n = m ? Math.max(1, n - 1) : n + 1; qtyInput.value = n;
      });
    }
    if (buyBtn) buyBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(form, true); });
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form, false); });

    // recommendations
    var recs = $('[data-recs]', root.closest('.shopify-section') || doc);
    if (recs && recs.dataset.url && !recs.dataset.loaded) {
      recs.dataset.loaded = '1';
      fetch(recs.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var src = $('[data-recs]', tmp);
        if (src && src.innerHTML.trim()) { recs.innerHTML = src.innerHTML; recs.hidden = false; }
      }).catch(function () {});
    }
    update();
  }

  /* ---------- collection filters ---------- */
  function initFilters() {
    var form = $('[data-filter-form]'); if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-autosubmit]')) {
        var row = e.target.closest('.col-check-row'); if (row) row.classList.toggle('checked', e.target.checked);
        form.submit();
      }
    });
    var sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var tg = $('[data-filter-toggle]'), sb = $('.col-sidebar');
    if (tg && sb) tg.addEventListener('click', function () { sb.classList.toggle('open'); });
  }

  /* ---------- cart ---------- */
  var cartBusy = false;
  function refreshCartSection() {
    var root = $('#cc-cart-root'); if (!root) return Promise.resolve();
    return fetch(CC.routes.cart + '?section_id=' + root.dataset.sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var fresh = $('#cc-cart-root', tmp);
        if (fresh) root.innerHTML = fresh.innerHTML;
      });
  }
  function changeLine(line, qty) {
    if (cartBusy) return; cartBusy = true;
    var body = $('.cart-body'); if (body) body.classList.add('is-loading');
    fetch(CC.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { CC.setCount(c.item_count); return refreshCartSection(); })
      .catch(function () { CC.toast(CC.strings.error); })
      .then(function () { cartBusy = false; });
  }

  /* ---------- global events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-drawer-open]')) { openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
    if (t.closest('.cc-drawer-links a')) { closeDrawer(); return; }
    if (t.closest('[data-search-toggle]')) { toggleSearch(); return; }

    var acc = t.closest('[data-acc-toggle]');
    if (acc) {
      var body = acc.parentNode.querySelector('.acc-body');
      var open = acc.getAttribute('aria-expanded') !== 'true';
      acc.setAttribute('aria-expanded', String(open));
      acc.classList.toggle('acc-head-open', open);
      if (body) body.hidden = !open;
      return;
    }

    var cq = t.closest('[data-cart-step]');
    if (cq) { changeLine(parseInt(cq.dataset.line, 10), parseInt(cq.dataset.qty, 10)); return; }
    var rm = t.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.line, 10), 0); return; }

    var promo = t.closest('[data-apply-discount]');
    if (promo) {
      var inp = $('[data-discount-input]'); var code = inp && inp.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CC.routes.cart);
      else if (inp) inp.focus();
    }
  });
  doc.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cart-input]');
    if (inp) changeLine(parseInt(inp.dataset.line, 10), Math.max(0, parseInt(inp.value, 10) || 0));
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); toggleSearch(false); }
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) { e.preventDefault(); var b = $('[data-apply-discount]'); if (b) b.click(); }
  });
  window.addEventListener('resize', function () { if (window.innerWidth > 900) closeDrawer(); });

  /* ---------- init (also re-runs in theme editor) ---------- */
  function init() {
    $$('[data-product-root]').forEach(function (r) { if (!r.dataset.ready) { r.dataset.ready = '1'; initProduct(r); } });
    initFilters();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { init(); closeDrawer(); });
  doc.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cc-header')) { closeDrawer(); }
  });
  doc.addEventListener('shopify:section:deselect', function () { closeDrawer(); });
})();
